<!-- Floating "Menu" ball button (black / previous styling) -->
<button
  id="advisorFab"
  class="business-menu-fab"
  [ngClass]="fabCorner"
  type="button"
  (click)="onFabClick()"
  (pointerdown)="startFabDrag($event)"
  [ngStyle]="fabStyle"
  [attr.aria-expanded]="isOpen"
  aria-label="Open advisors"
>
  <i class="fa fa-eye advisory-icon" aria-hidden="true"></i>
  <span class="clari-text advisory-label">Advisors</span>
</button>

<div
  class="pop-play-player"
  *ngIf="popPlayEnabled"
  [class.large]="popPlaySize === 'large'"
  [ngStyle]="popPlayStyle"
>
  <div class="pop-play-header" (pointerdown)="startPopPlayDrag($event)">
    <div class="pop-play-title">
      <i class="fa-solid fa-eye"></i>
      <span>AI Advisors</span>
    </div>
    <div class="pop-play-actions">
      <button type="button" class="pop-play-icon" (click)="togglePopPlaySize()" aria-label="Resize AI Advisors Board player">
        <i class="fa-solid" [class.fa-down-left-and-up-right-to-center]="popPlaySize === 'large'" [class.fa-up-right-and-down-left-from-center]="popPlaySize !== 'large'"></i>
      </button>
      <button type="button" class="pop-play-icon" (click)="togglePopPlay()" aria-label="Toggle pop and play mode">
        <i class="fa-solid fa-arrow-up-right-from-square"></i>
      </button>
      <button type="button" class="pop-play-icon" (click)="closePopPlay()" aria-label="Close pop and play">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
  <div class="pop-play-body">
    <div class="coach-nav">
      <button type="button" class="coach-nav-btn" (click)="navigateCoachEntry(-1)" [disabled]="selectedCoachIndex >= coachEntries.length - 1">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <span class="coach-nav-meta">{{ selectedCoachIndex + 1 }} / {{ coachEntries.length || 1 }}</span>
      <button type="button" class="coach-nav-btn" (click)="navigateCoachEntry(1)" [disabled]="selectedCoachIndex <= 0">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>

    <div class="pop-play-empty" *ngIf="!activeCoachEntry">
      Ask a question to start building your AI Advisors log.
    </div>

    <div class="pop-play-entry" *ngIf="activeCoachEntry">
      <div class="pop-play-model">{{ activeCoachEntry.assistantModelName || activeCoachEntry.assistantModelId || 'Assistant' }}</div>
      <div class="pop-play-question">
        <span class="coach-entry-label">You:</span>
        <span>{{ truncateCoachText(activeCoachEntry.userText, 100) }}</span>
      </div>
      <div class="pop-play-answer">
        <span class="coach-entry-label">Answer:</span>
        <span>{{ truncateCoachText(activeCoachEntry.assistantText, 120) }}</span>
      </div>
      <div class="coach-entry-tally" *ngIf="getSavingsCount(activeCoachEntry) || getPowerCount(activeCoachEntry)">
        <span class="coach-entry-savings" *ngIf="getSavingsCount(activeCoachEntry)">
          {{ getSavingsCount(activeCoachEntry) }} <span class="dollar">$</span>
        </span>
        <span class="coach-entry-power" *ngIf="getPowerCount(activeCoachEntry)">
          {{ getPowerCount(activeCoachEntry) }} <i class="fa-solid fa-dumbbell"></i>
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Full-screen overlay: 100vw / 100vh, black + same gradient rule -->
<div
  class="business-menu-overlay"
  [class.open]="isOpen"
  (click)="onBackdropClick()"
  role="dialog"
  aria-modal="true"
  [attr.aria-hidden]="!isOpen"
>
  <!-- Panel wrapper (clicks inside do not close) -->
  <div class="business-menu-panel" [ngClass]="openStyle" (click)="stopPropagation($event)">
    <!-- Top row -->
    <div class="top-row">
      <a [routerLink]="['/clarichat']" class="logo-link" (click)="closeMenu()">
        <img class="grid-item-logo" src="assets/iamclari2.png" />
      </a>
      <div class="top-row-actions">
        <button
          class="pop-play-btn"
          type="button"
          (click)="togglePopPlay()"
          aria-label="Enable pop and play advixssors"
        >
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
        <button class="close-btn" type="button" (click)="closeMenu()" aria-label="Close menu">
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>

    <!-- Reasoning Dropdown (optional) -->
    <div class="reasoning-level-dropdown-container" *ngIf="showReasoningDropdown">
      <div class="reasoning-dropdown" [class.open]="reasoningDropdownOpen">
        <button
          class="reasoning-dropdown-trigger"
          (click)="toggleReasoningDropdown()"
          type="button"
          aria-label="Select reasoning level"
        >
          <span class="reasoning-selected">{{ getReasoningLabel(selectedReasoningLevel) }}</span>
          <i class="fas fa-chevron-down" [class.rotated]="reasoningDropdownOpen"></i>
        </button>

        <div class="reasoning-dropdown-menu" *ngIf="reasoningDropdownOpen">
          <button
            class="reasoning-option"
            [class.selected]="selectedReasoningLevel === 'auto'"
            (click)="selectReasoningLevel('auto')"
            type="button"
          >
            <div class="reasoning-option-content">
              <div class="reasoning-option-title">Advisors</div>
              <div class="reasoning-option-description">Decides how long to think</div>
            </div>
            <i class="fas fa-check" *ngIf="selectedReasoningLevel === 'auto'"></i>
          </button>

          <button
            class="reasoning-option"
            [class.selected]="selectedReasoningLevel === 'instant'"
            (click)="selectReasoningLevel('instant')"
            type="button"
          >
            <div class="reasoning-option-content">
              <div class="reasoning-option-title">Advisors</div>
              <div class="reasoning-option-description">Answers right away</div>
            </div>
            <i class="fas fa-check" *ngIf="selectedReasoningLevel === 'instant'"></i>
          </button>

          <button
            class="reasoning-option"
            [class.selected]="selectedReasoningLevel === 'thinking'"
            (click)="selectReasoningLevel('thinking')"
            type="button"
          >
            <div class="reasoning-option-content">
              <div class="reasoning-option-title">Advisors</div>
              <div class="reasoning-option-description">Thinks longer for better answers</div>
            </div>
            <i class="fas fa-check" *ngIf="selectedReasoningLevel === 'thinking'"></i>
          </button>

          <button
            class="reasoning-option"
            [class.selected]="selectedReasoningLevel === 'pro'"
            (click)="selectReasoningLevel('pro')"
            type="button"
          >
            <div class="reasoning-option-content">
              <div class="reasoning-option-title">Advisors</div>
              <div class="reasoning-option-description">Research-grade intelligence</div>
            </div>
            <i class="fas fa-check" *ngIf="selectedReasoningLevel === 'pro'"></i>
          </button>

          <div class="reasoning-separator"></div>

          <div class="legacy-models-section">
            <button
              class="legacy-models-trigger"
              [class.expanded]="legacyModelsExpanded"
              (click)="toggleLegacyModels()"
              type="button"
            >
              <span>Advisors</span>
              <i class="fas fa-chevron-right" [class.rotated]="legacyModelsExpanded"></i>
            </button>

            <div class="legacy-models-content" *ngIf="legacyModelsExpanded">
              <div class="legacy-models-placeholder">Legacy models coming soon</div>
            </div>
          </div>

          <div class="reasoning-dropdown-footer">
            <div class="credits-message">Limits reached. Add credits to your account</div>
            <button class="add-credits-btn" type="button" (click)="openAddCredits()">
              <i class="fa fa-eye"></i>
              <span>Advisors</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="menu" aria-label="Main navigation">
      <!-- COACH -->
      <div class="section coach-section">
        <button
          type="button"
          class="section-header"
          (click)="toggleSection('coach')"
          [attr.aria-expanded]="isExpanded('coach')"
        >
          <span class="header-left">
            <i class="fa-solid fa-eye ali-icon beige"></i>
            <span class="section-title">AI Advisors Board</span>
          </span>
          <span class="chev" [class.open]="isExpanded('coach')">›</span>
        </button>

        <div class="section-body" *ngIf="isExpanded('coach')">
          <div class="coach-legend">
            <div class="coach-legend-title">Model legend</div>
            <div class="coach-legend-list" *ngIf="coachLegendModels.length; else noCoachLegend">
              <div class="coach-legend-item" *ngFor="let model of coachLegendModels">
                <span class="legend-pill legend-pill-green">{{ model }}</span>
                <span class="legend-pill legend-pill-red">{{ model }}</span>
              </div>
            </div>
            <ng-template #noCoachLegend>
              <div class="coach-legend-empty">No models used in this session yet.</div>
            </ng-template>
          </div>

          <button class="coach-pop-btn" type="button" (click)="togglePopPlay()">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
            Advisors
          </button>

          <div class="coach-preference">
            <div class="coach-preference-header">
              <span class="coach-preference-title">Cost ↔ Performance</span>
              <span class="coach-preference-value">{{ costPerformancePreference }}%</span>
            </div>
            <input
              class="coach-slider"
              type="range"
              min="0"
              max="100"
              [value]="costPerformancePreference"
              (input)="updatePreference($any($event.target).value)"
              aria-label="Cost versus performance preference"
            />
            <div class="coach-preference-labels">
              <span>Lower cost</span>
              <span>Higher performance</span>
            </div>
          </div>

          <div class="coach-log">
            <div class="coach-log-title-row">
              <div class="coach-log-title">Recent AI Advisors Board guidance (last 10)</div>
              <div class="coach-nav">
                <button type="button" class="coach-nav-btn" (click)="navigateCoachEntry(-1)" [disabled]="selectedCoachIndex >= coachEntries.length - 1">
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <span class="coach-nav-meta">{{ selectedCoachIndex + 1 }} / {{ coachEntries.length || 1 }}</span>
                <button type="button" class="coach-nav-btn" (click)="navigateCoachEntry(1)" [disabled]="selectedCoachIndex <= 0">
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <div class="coach-empty" *ngIf="coachEntries.length === 0">
              Ask a question to start building your AI Advisors Board log.
            </div>

            <div
              class="coach-entry"
              *ngFor="let entry of coachEntries; let i = index"
              [class.active]="i === selectedCoachIndex"
              (click)="selectCoachEntry(i)"
            >
              <div class="coach-entry-header">
                <div class="coach-entry-model">
                  {{ entry.assistantModelName || 'Assistant' }}
                </div>
                <div class="coach-entry-meta">
                  <span *ngIf="entry.tokensUsed !== null && entry.tokensUsed !== undefined">Tokens: {{ entry.tokensUsed }}</span>
                  <span *ngIf="entry.tokensUsed === null || entry.tokensUsed === undefined">Tokens: n/a</span>
                </div>
              </div>

              <div class="coach-entry-body">
                <div class="coach-entry-question">
                  <span class="coach-entry-label">You:</span>
                  <span>{{ truncateCoachText(entry.userText, 120) }}</span>
                </div>
                <div class="coach-entry-answer">
                  <span class="coach-entry-label">Answer:</span>
                  <span>{{ truncateCoachText(entry.assistantText, 180) }}</span>
                </div>
              </div>

              <div class="coach-entry-status" *ngIf="entry.status === 'pending'">
                AI Advisors Board is reviewing this exchange...
              </div>
              <div class="coach-entry-status" *ngIf="entry.status === 'error'">
                AI Advisors Board failed: {{ entry.errorMessage || 'Unable to evaluate.' }}
              </div>
              <div class="coach-entry-status" *ngIf="entry.status === 'skipped'">
                AI Advisors Board skipped this response: {{ entry.errorMessage }}
              </div>

              <div class="coach-entry-summary" *ngIf="entry.summary">
                {{ entry.summary }}
              </div>

              <div class="coach-entry-tally" *ngIf="getSavingsCount(entry) || getPowerCount(entry)">
                <span class="coach-entry-savings" *ngIf="getSavingsCount(entry)">
                  {{ getSavingsCount(entry) }} <span class="dollar">$</span>
                </span>
                <span class="coach-entry-power" *ngIf="getPowerCount(entry)">
                  {{ getPowerCount(entry) }} <i class="fa-solid fa-dumbbell"></i>
                </span>
              </div>

              <div class="coach-suggestions" *ngIf="entry.status === 'ready' && entry.suggestions?.length">
                <div class="coach-suggestions-title">Suggested models</div>
                <div class="coach-suggestion" *ngFor="let suggestion of entry.suggestions">
                  <div class="coach-suggestion-header">
                    <span class="coach-suggestion-name">
                      {{ suggestion.modelName || suggestion.modelId }}
                    </span>
                    <span class="coach-suggestion-id">{{ suggestion.modelId }}</span>
                  </div>
                  <div class="coach-suggestion-reason">{{ suggestion.reason }}</div>
                  <div class="coach-suggestion-notes" *ngIf="suggestion.tradeoffs">
                    Tradeoffs: {{ suggestion.tradeoffs }}
                  </div>
                  <div class="coach-suggestion-metrics">
                    <span *ngIf="suggestion.valueNote">Value: {{ suggestion.valueNote }}</span>
                    <span *ngIf="suggestion.speedNote">Speed: {{ suggestion.speedNote }}</span>
                    <span *ngIf="suggestion.qualityNote">Quality: {{ suggestion.qualityNote }}</span>
                    <span *ngIf="suggestion.relevanceNote">Relevance: {{ suggestion.relevanceNote }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Conversations -->
      <div class="convos" *ngIf="isLoggedIn && (recentConversations.length > 0 || loadingConversations)">
        <div class="convos-title">Conversations</div>

        <div class="convos-loading" *ngIf="loadingConversations">Loading conversations...</div>

        <button
          class="convo-item"
          type="button"
          *ngFor="let conv of recentConversations"
          (click)="loadConversation(conv.id)"
          [title]="conv.topic || 'Conversation'"
        >
          <span class="convo-topic">{{ truncateTopic(conv.topic || 'Conversation') }}</span>
          <span class="convo-meta" *ngIf="conv.messages?.length">
            <i class="fa-solid fa-message"></i>
            {{ conv.messages.length }}
          </span>
        </button>
      </div>
    </nav>
  </div>
</div>
